import _ from "lodash";
import pluralize from "pluralize";
export const isEmptyOrWhitespace = (value) => {
    return !value || !/\S/.test(value);
};
export const toCorrectPlural = (value, count) => pluralize(value, count, true);
export const toSingular = (value) => pluralize.singular(value);
export const toPlural = (value) => pluralize(value);
export const lowerCase = (value) => value.toLowerCase();
export const upperCase = (value) => value.toUpperCase();
export const startCase = (value) => _.startCase(value);
export const sentenceCase = (value) => lowerCase(value).replace(/(^\w)|\.\s+(\w)/gm, upperCase);
export const pascalCaseToStartCase = (value) => startCase(value.replace(/(?<!^)([A-Z][a-z]|(?<=[a-z])[A-Z])/gm, " $&"));
export const getPrintable = (e) => {
    if (!e.key || e.shiftKey || e.ctrlKey || e.metaKey)
        return { isPrintable: false };
    if (e.key.length === 1 || (e.key.length > 1 && /[^a-zA-Z0-9]/.test(e.key)))
        return {
            isPrintable: true,
            character: e.key,
        };
    return { isPrintable: false };
};
